/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { bulkPartialPatchDependencyPairSchema } from './bulkPartialPatchDependencyPairSchema';
import { bulkPartialPatchDependencySkipSchema } from './bulkPartialPatchDependencySkipSchema';

export const bulkPartialPatchDependencyResultSchema = z.object({
  get acceptedPairs() {
    return z.array(bulkPartialPatchDependencyPairSchema);
  },
  get skipped() {
    return z.array(bulkPartialPatchDependencySkipSchema);
  },
});
